import { api, EMAIL_SUCCESS_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const forgotVerification = (data: PropertyType): Promise<string | void> =>
	api.post('/forgot-verification', mapEntityToApi(data)).then(() => {
		return EMAIL_SUCCESS_MESSAGE;
	});
